import { call } from "redux-saga/effects";

let getAccumulatedUsagesPrepaidModule = null;
export function* getAccumulatedUsagesPrepaid({}) {
  try {
    if (!getAccumulatedUsagesPrepaidModule) {
      getAccumulatedUsagesPrepaidModule = yield call(() =>
        import("./get-accumulated-usage")
      );
    }
    yield call(
      getAccumulatedUsagesPrepaidModule.getAccumulatedUsagesPrepaid,
      {}
    );
  } catch (error) {
    console.log(error);
  }
}

let getTarifDetailsPrepaidModule = null;
export function* getTarifDetailsPrepaid({}) {
  try {
    if (!getTarifDetailsPrepaidModule) {
      getTarifDetailsPrepaidModule = yield call(() =>
        import("./get-tarif-detail")
      );
    }
    yield call(getTarifDetailsPrepaidModule.getTarifDetailsPrepaid, {});
  } catch (error) {
    console.log(error);
  }
}

let getDetailsUsagesPrepaidModule = null;
export function* getDetailsUsagesPrepaid({ payload }) {
  try {
    if (!getDetailsUsagesPrepaidModule) {
      getDetailsUsagesPrepaidModule = yield call(() =>
        import("./get-detailed-usage")
      );
    }
    yield call(getDetailsUsagesPrepaidModule.getDetailsUsagesPrepaid, {
      payload,
    });
  } catch (error) {
    console.log(error);
  }
}

let getBalancePrepaidModule = null;
export function* getBalancePrepaid({}) {
  try {
    if (!getBalancePrepaidModule) {
      getBalancePrepaidModule = yield call(() => import("./get-balance"));
    }
    yield call(getBalancePrepaidModule.getBalancePrepaid, {});
  } catch (error) {
    console.log(error);
  }
}

let getListMovementPrepaidModule = null;
export function* getListMovementPrepaid({ productId }) {
  try {
    if (!getListMovementPrepaidModule) {
      getListMovementPrepaidModule = yield call(() =>
        import("./get-movement-list")
      );
    }
    yield call(getListMovementPrepaidModule.getListMovementPrepaid, {
      productId,
    });
  } catch (error) {
    console.log(error);
  }
}

let getRechargePrepaidModule = null;
export function* getRechargePrepaid({data}) {
  try {
    if (!getRechargePrepaidModule) {
      getRechargePrepaidModule = yield call(() => import("./recharge"));
    }
    yield call(getRechargePrepaidModule.getRechargePrepaid, {
      data,
    });
  } catch (error) {
    console.log(error);
  }
}
